import Actions from '../actions'

function setNewGameTab (isTabOpen) {
  return {
    type: Actions.UI_SET_NEW_GAME_TAB,
    payload: isTabOpen
  }
}

let enums = {
  pageNames: {
    ADMIN: 'ADMIN',
    OVERVIEW: 'OVERVIEW',
    GAME: 'GAME',
    RULES: 'RULES',
  }
}

function setActivePage (pageName) {
  return {
    type: Actions.UI_SET_ACTIVE_PAGE,
    payload: pageName,
  }
}

function setInviteTab (isTabOpen) {
  return {
    type: Actions.UI_SET_INVITE_TAB,
    payload: isTabOpen
  }
}

function setActiveTab (isTabOpen) {
  return {
    type: Actions.UI_SET_ACTIVE_TAB,
    payload: isTabOpen
  }
}

function setPastTab (isTabOpen) {
  return {
    type: Actions.UI_SET_PAST_TAB,
    payload: isTabOpen
  }
}

export default {
  enums,
  setNewGameTab,
  setActivePage,
  setInviteTab,
  setActiveTab,
  setPastTab,
}
